import { render, staticRenderFns } from "./BrokerClientListPage.vue?vue&type=template&id=5a3f0852&"
import script from "./BrokerClientListPage.vue?vue&type=script&lang=js&"
export * from "./BrokerClientListPage.vue?vue&type=script&lang=js&"
import style0 from "./BrokerClientListPage.vue?vue&type=style&index=0&id=5a3f0852&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports